import { $Shape } from "utility-types";
import { LazyStore } from "../../utils/Store";
import type { MaxQuantitySettings, StoreConfig } from "../../model/StoreInformation";
import { SessionStore } from "../../uidispatcherapi/SessionStore";
import { getStoreConfig } from "../../server/StoreInfoRequests";
export type SelectedStoreInfoStoreState = {
	currentStore:
		| {
				id?: string | null;
				info: StoreConfig | null | undefined;
		  }
		| null
		| undefined;
};
export class SelectedStoreInfoStoreImpl extends LazyStore {
	state!: SelectedStoreInfoStoreState;
	updateState = (
		diff: $Shape<SelectedStoreInfoStoreState>,
		predicate: (arg0: SelectedStoreInfoStoreState) => boolean = () => true,
	) => {
		if (!predicate(this.state)) return;
		this.state = { ...this.state, ...diff };
		this.trigger();
	};

	constructor(sessionStore: typeof SessionStore) {
		super();

		this.onArm = () => {
			this.resetState();
			this.listenTo(sessionStore, () => {
				this.handleUpdate({
					country: sessionStore.getCountry(),
					storeId: sessionStore.getSelectedStoreId(),
				}).catch((error) => {
					console.error("handleUpdate in SelectedStoreInfoStore failed with ", error);
				});
			});
			this.handleUpdate({
				country: sessionStore.getCountry(),
				storeId: sessionStore.getSelectedStoreId(),
			}).catch((error) => {
				console.error("handleUpdate in SelectedStoreInfoStore failed with ", error);
			});
		};

		this.onDisarm = () => {
			this.resetState();
		};
	}

	resetState = () => {
		this.state = {
			currentStore: null,
		};
	};

	async handleUpdate({ country, storeId }: { country: string; storeId: string | null | undefined }) {
		if (storeId === null) {
			this.updateState({
				currentStore: null,
			});
		}

		if (!storeId || stateBelongsToStoreId(this.state, storeId)) {
			return;
		}

		this.updateState({
			currentStore: {
				id: storeId,
				info: null,
			},
		});

		// Request will return 401 if user is not logged in
		if (!SessionStore.loggedIn()) {
			return;
		}

		const info = await getStoreConfig({
			country,
			storeId,
		});
		this.updateState(
			{
				currentStore: { ...this.state.currentStore, info },
			},
			(state) => stateBelongsToStoreId(state, storeId),
		);
	}

	getState = () => this.state;

	getCurrentMaxQuantitySettings(): MaxQuantitySettings {
		const settings = this.getState()?.currentStore?.info?.maxQuantitySettings;
		return settings
			? {
					maxQuantityNormal: settings.maxQuantityPiece,
					maxQuantityWeight: settings.maxQuantityWeight,
				}
			: SelectedStoreInfoStoreImpl.defaultSettings;
	}

	static get defaultSettings(): MaxQuantitySettings {
		return {
			maxQuantityNormal: 99999,
			maxQuantityWeight: 99999.999,
		};
	}
}

const stateBelongsToStoreId = (state: SelectedStoreInfoStoreState, storeId: string) =>
	(state.currentStore && state.currentStore.id === storeId) || false;

export default new SelectedStoreInfoStoreImpl(SessionStore);
